import {JSONItemBase} from "PDFLib/core/writers/JSONWriter/JSONItem/JSONItemBase";
import PDFTrailer from "PDFLib/core/document/PDFTrailer";

export class TrailerJsonItem extends JSONItemBase{
    GetType() {
        return 'TR';
    }

    public LastXRef:string;

    constructor(trailer:PDFTrailer) {
        super();
        this.LastXRef=trailer.lastXRefOffset;
    }
}